const DEFAULT_COLOR = "gray";
/**
 * System color definitions mapping color names to Tailwind CSS classes
 */
export const COLORS = {
  gray: "text-gray-400",
  "indigo-light": "text-indigo-500",
  green: "text-green-500",
  red: "text-red-500",
  orange: "text-orange-500",
  yellow: "text-yellow-500",
} as const;
export const COLORS_LIST = Object.keys(COLORS) as Color[];

export type Color = keyof typeof COLORS;

/**
 * Type guard to check if a string is a valid color
 */
export const isValidColor = (color: unknown): color is Color => {
  if (typeof color !== "string") {
    return false;
  }

  return Object.keys(COLORS).includes(color);
};

/**
 * Safely cast an unknown value to a valid color, defaulting to gray
 */
export const castColor = (color: unknown): Color => {
  if (typeof color !== "string" || !isValidColor(color)) {
    return DEFAULT_COLOR;
  }
  return color;
};

/**
 * Get the Tailwind CSS class for a given color
 */
export const getColorClass = (color: Color | string): string => {
  const validColor = castColor(color);
  return COLORS[validColor];
};
